import { version } from './../../package.json';

export const environment = {
  production: true,
  host: 'https://cadenatest.dian.gov.co/',
  version,
  rulesDocuments: {
    maxSizeInBites: 6291456,
    allowedFormats: [
      { type: 'application/pdf', alias: 'pdf' },
      { type: 'image/jpeg', alias: 'jpeg, jpg' },
      { type: 'image/png', alias: 'png' },
      {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        alias: 'xlxs'
      },
      {
        type:
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        alias: 'docx'
      }
    ]
  },
  timeToRememberSession: 300000
};
